import { Component, Vue } from 'vue-property-decorator';
import { PAGE_NAMES } from '@/constants';

@Component
export default class Notification extends Vue {
  navigateToHomePage(): void {
    this.$router.push({ name: PAGE_NAMES.HOME });
  }
}
